import { useEffect } from 'react';
import { useParams, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGS = ['en', 'es'];
const DEFAULT_LANG = 'es';

export default function LanguageWrapper() {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!lang || !SUPPORTED_LANGS.includes(lang)) {
      const pathParts = location.pathname.split('/').filter(Boolean);
      
      // If the first part looks like a language code (2 chars), replace it
      if (pathParts.length > 0 && pathParts[0].length === 2) {
        pathParts[0] = DEFAULT_LANG;
      } else {
        // Otherwise prepend it
        pathParts.unshift(DEFAULT_LANG);
      }
      
      const newPath = `/${pathParts.join('/')}${location.search}${location.hash}`;
      navigate(newPath, { replace: true });
      return;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n, navigate, location]);

  if (!lang || !SUPPORTED_LANGS.includes(lang)) {
    return null;
  }

  return <Outlet />;
}
